import { handleActions, createAction } from 'redux-actions';
import { get, cloneDeep } from 'lodash';
import { DETAILS_TAB } from '../consts/detailsTabs';
import { SENT_FOR_TRANSPORT } from '../consts/offerStatus';

// OFFERS DETAILS
export const FETCH_OFFERS_DETAILS = createAction('FETCH/OFFERS/DETAILS');
export const FETCH_OFFERS_DETAILS_SUCCESS = createAction('FETCH/OFFERS/DETAILS/SUCCESS');
export const FETCH_OFFERS_DETAILS_FAIL = createAction('FETCH/OFFERS/DETAILS/FAIL');
// BETS
export const POST_NEW_BET = createAction('POST/NEW/BET');
export const POST_NEW_BET_SUCCESS = createAction('POST/NEW/BET/SUCCESS');
export const POST_NEW_BET_FAIL = createAction('POST/NEW/BET/FAIL');
// BUY NOW CONTRACTS
export const ACCEPT_BUY_NOW_CONTRACT = createAction('ACCEPT/BUY_NOW_CONTRACT');
export const ACCEPT_BUY_NOW_CONTRACT_SUCCESS = createAction('ACCEPT/BUY_NOW_CONTRACT/SUCCESS');
export const ACCEPT_BUY_NOW_CONTRACT_FAIL = createAction('ACCEPT/BUY_NOW_CONTRACT/FAIL');
// PICK-UP DATE
export const SET_PICKUP_DATE = createAction('SET/PICKUP/DATE');
export const SET_PICKUP_DATE_SUCCESS = createAction('SET/PICKUP/DATE/SUCCESS');
export const SET_PICKUP_DATE_FAIL = createAction('SET/PICKUP/DATE/FAIL');
// PICK-UP DATE EASY TRANSPORT
export const SET_TRANSFERRED_FOR_TRANSPORT = createAction('SET/TRANSFERRED/FOR/TRANSPORT');
export const SET_TRANSFERRED_FOR_TRANSPORT_SUCCESS = createAction('SET/TRANSFERRED/FOR/TRANSPORT/SUCCESS');
export const SET_TRANSFERRED_FOR_TRANSPORT_FAIL = createAction('SET/TRANSFERRED/FOR/TRANSPORT/FAIL');
// VEHICLE PICKED-UP DATE
export const SET_VEHICLE_PICKED_UP_DATE = createAction('SET/VEHICLE/PICKEDUP/DATE');
export const SET_VEHICLE_PICKED_UP_DATE_SUCCESS = createAction('SET/VEHICLE/PICKEDUP/DATE/SUCCESS');
export const SET_VEHICLE_PICKED_UP_DATE_FAIL = createAction('SET/VEHICLE/PICKEDUP/DATE/FAIL');

export const SET_DETAILS_TAB = createAction('SET/DETAILS/TAB');
export const CLEAR_DETAILS_DATA = createAction('CLEAR/DETAILS/DATA');

const initialState = {
  errorOffersDetails: null,
  errorBetsDetails: null,
  isLoadingPickupDate: false,
  isLoadingTransferredForTransport: false,
  isLoadingPickedUpDate: false,
  isLoadingBuyNow: false,
  data: {},
  detailsActiveTab: DETAILS_TAB,
  buyNowContractAccepted: false,
};

const offersDetailsReducer = handleActions(
  {
    [CLEAR_DETAILS_DATA]: (state) => {
      const newState = cloneDeep(state);
      newState.data = get(initialState, 'data');
      newState.buyNowContractAccepted = false;
      return newState;
    },
    [FETCH_OFFERS_DETAILS_SUCCESS]: (state, { payload: offerDetails, }) => {
      return { ...state, data: offerDetails, };
    },
    [FETCH_OFFERS_DETAILS_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, errorOffersDetails: error, };
    },
    [POST_NEW_BET]: (state) => {
      return { ...state, duringBetting: true, };
    },
    [POST_NEW_BET_SUCCESS]: (
      state,
      {
        payload: {
          bet: { highest, value, },
        },
      }
    ) => {
      const newState = cloneDeep(state);
      newState.data.my_bet_is_highest = highest;
      newState.data.highest_bet_value = value;
      newState.errorBetsDetails = null;
      return newState;
    },
    [POST_NEW_BET_FAIL]: (state, { payload: { errors, highest_bet, }, }) => {
      const newState = cloneDeep(state);
      newState.data.highest_bet_value = highest_bet;
      newState.errorBetsDetails.errors = errors;
      return newState;
    },

    [SET_PICKUP_DATE]: (state) => {
      return { ...state, isLoadingPickupDate: true, };
    },
    [SET_PICKUP_DATE_SUCCESS]: (state, { payload, }) => {
      return { ...state, isLoadingPickupDate: false, ...payload, };
    },
    [SET_PICKUP_DATE_FAIL]: (state) => {
      return { ...state, isLoadingPickupDate: false, };
    },
    [SET_TRANSFERRED_FOR_TRANSPORT]: (state) => {
      return { ...state, isLoadingTransferredForTransport: true, };
    },
    [SET_TRANSFERRED_FOR_TRANSPORT_SUCCESS]: (state) => {
      const newState = cloneDeep(state);
      newState.isLoadingTransferredForTransport = false;
      newState.data.status = SENT_FOR_TRANSPORT;
      return newState;
    },
    [SET_TRANSFERRED_FOR_TRANSPORT_FAIL]: (state) => {
      return { ...state, isLoadingTransferredForTransport: false, };
    },
    [SET_VEHICLE_PICKED_UP_DATE]: (state) => {
      return { ...state, isLoadingPickedUpDate: true, };
    },
    [SET_VEHICLE_PICKED_UP_DATE_SUCCESS]: (state, { payload: { pick_up_date, }, }) => {
      return { ...state, isLoadingPickedUpDate: false, data: { ...state.data, pick_up_date, }, };
    },
    [SET_VEHICLE_PICKED_UP_DATE_FAIL]: (state) => {
      return { ...state, isLoadingPickedUpDate: false, };
    },
    [SET_DETAILS_TAB]: (state, { payload: { tabName, }, }) => {
      return { ...state, detailsActiveTab: tabName, };
    },
    [ACCEPT_BUY_NOW_CONTRACT]: (state) => {
      return { ...state, isLoadingBuyNow: true, };
    },
    [ACCEPT_BUY_NOW_CONTRACT_SUCCESS]: (state) => {
      return { ...state, isLoadingBuyNow: false, buyNowContractAccepted: true, };
    },
    [ACCEPT_BUY_NOW_CONTRACT_FAIL]: (state) => {
      return { ...state, isLoadingBuyNow: false, };
    },
  },
  initialState
);

export default offersDetailsReducer;
